import { useEffect, useState } from "react";
import { FormattedMessage as FM } from "react-intl";
import { signal } from "@preact/signals-react";
import { Fragment } from "react";

import { useStore } from "storev2/formStore";
import TrytonForm from "componentsv2/form/TrytonForm";
import Button from "componentsv2/button/Button";
import { layout as layoutGuest } from "./model/layoutGuest";
import ExtraFields from "./ExtraFields";
import proxy from "api/proxy";
import { validateForm } from "componentsv2/tools/functions";
import {
  MessageContainer,
  useMessage,
} from "componentsv2/experimental/Message";

const recId = signal(null);
const showMessage = signal(false);

// extra field
const cradle = signal(false);
const description_cradle = signal("");
const transfer = signal(false);
const description_transfer = signal("");
const pet = signal(false);
const description_pet = signal("");

const main_guest = signal(null);

const attrsExtraFields = {
  cradle,
  description_cradle,
  transfer,
  description_transfer,
  pet,
  description_pet,
};

function buildComment() {
  const parts = [];

  if (cradle.value) {
    let text = "Cuna: Sí";
    if (description_cradle.value) text += ` - ${description_cradle.value}`;
    parts.push(text);
  }

  if (transfer.value) {
    let text = "Transfer: Sí";
    if (description_transfer.value) text += ` - ${description_transfer.value}`;
    parts.push(text);
  }

  if (pet.value) {
    let text = "Mascota: Sí";
    if (description_pet.value) text += ` - ${description_pet.value}`;
    parts.push(text);
  }
  return parts.join(" | ");
}

function FormGuest({ currentFolio }) {
  const { messages, success, warning, hide } = useMessage();
  const _layoutGuest = layoutGuest();
  const { newRecord, reset } = useStore();
  const [data, setData] = useState(null);

  async function initRecord() {
    const id = await newRecord(_layoutGuest);
    recId.value = id;

    const { findRecord } = useStore.getState();
    const formRecord = findRecord(id);

    if (formRecord) {
      formRecord.store.main_guest = main_guest.value === null;
      formRecord.active.main_guest = main_guest.value === null;
    }
  }

  async function addGuest() {
    const { findRecord } = useStore.getState();
    const formRecord = findRecord(recId.value);

    if (!formRecord?.store) return;

    const forMainGuest = main_guest.value === null;
    const guestData = {
      ...formRecord.store,
      folio: currentFolio.value,
      main_guest: forMainGuest,
    };

    const { msg } = validateForm(
      formRecord,
      guestData,
      formRecord.layout.fields,
    );

    if (msg !== "ok") {
      warning("app.webcheckin.msg_missing");

      return;
    } else if (msg === "ok") {
      success("app.webcheckin.msg_ok");
    }

    const getComment = buildComment();
    const { error } = await proxy.saveQuery({
      model: "hotel.folio.guest",
      storeRec: guestData,
    });
    if (error) {
      console.error(error);
      return;
    }
    if (getComment.trim()) {
      await proxy.saveQuery({
        model: "hotel.folio",
        storeRec: {
          id: currentFolio.value,
          comments: getComment,
        },
      });
    }
    reset(true);

    cradle.value = false;
    description_cradle.value = "";
    transfer.value = false;
    description_transfer.value = "";
    pet.value = false;
    description_pet.value = "";

    await getGuest();
    await initRecord();
  }

  async function getGuest() {
    if (!currentFolio?.value) return;

    const dom = [["id", "=", currentFolio.value]];
    const { data } = await proxy.search("hotel.folio", dom, [
      "guests.name",
      "guests.type_guest",
      "guests.main_guest",
    ]);
    if (!data?.length) return;
    const folio = data[0];
    if (folio["guests."]?.length) {
      const main = folio["guests."].find((g) => g.main_guest === true);
      main_guest.value = main || null;
    } else {
      main_guest.value = null;
    }
    setData(folio);
  }

  useEffect(() => {
    if (!currentFolio?.value) return;
    (async () => {
      await getGuest();
      await initRecord();
    })();
  }, [currentFolio.value]);

  function RegisteredGuests() {
    return (
      <div className="rounded-md bg-white h-1/2 md:block hidden ">
        <div className="bg-neutral-900  text-gray-50 w-full flex justify-between py-3 px-3 font-medium">
          <FM id="app.webcheckin.name_guest" />
          {/* <FM id="app.webcheckin.type_guest" />*/}
        </div>
        <div className="max-h-[200px] overflow-y-scroll">
          {data?.["guests."]?.map((guest, i) => (
            <div
              key={i}
              className="flex justify-between px-3 py-2 odd:bg-white even:bg-gray-100"
            >
              <span className="uppercase truncate">{guest.name}</span>
              {/* <span>{guest.type_guest === "adult" ? "Adulto" : "Niño"}</span>*/}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <Fragment>
      <div className="mx-auto !w-full md:flex my-4 md:space-x-6">
        <div className="md:w-2/3">
          {main_guest.value === null && (
            <h2 className="text-center underline p-4">
              <FM id="app.webcheckin.main_guest_description" />
            </h2>
          )}
          {recId.value && (
            <TrytonForm storeId={recId.value} layout={_layoutGuest} />
          )}

          <div className="md:w-1/3 space-y-2 sm:hidden">
            <ExtraFields {...attrsExtraFields} />
          </div>
          <div className="flex justify-center mb-4 md:mb-0">
            <Button
              type="button"
              onClick={addGuest}
              color="blue"
              size="w-fit h-10"
              style="md:mt-2 !border-none"
            >
              <FM id="app.webcheckin.add_guest" />
            </Button>
          </div>
        </div>
        <div className="md:w-1/3 space-y-2  sm:block hidden ">
          <RegisteredGuests />
          <ExtraFields {...attrsExtraFields} />
        </div>
      </div>
      <MessageContainer
        messages={messages}
        onMessageClose={hide}
        position="top-center"
      />
    </Fragment>
  );
}

export default FormGuest;
